import React from 'react';
import { Field, reduxForm, FieldArray } from 'redux-form';
import { validate, validatorFromFunction, validators, combine } from 'validate-redux-form';
import { renderField, renderTextArea } from '../../../Utils/renderField';
import { Link } from 'react-router-dom';
import { TiposCuentas, Monedas } from '../../../../../utility/constants';
import {SelectField, renderSelectField} from '../../../Utils/renderField/renderField.js'

const renderCuentas = ({fields, meta: {error, submitFailed }, contactos}) => (
    <div className=" col-sm-12 p-0">
        <div className=" col-sm-12 form-group np-r p-0">
            <div className="react-bs-container-header table-header-wrapper">
                <table className="table table-striped table-highlight mb-0">
                    <thead>
                    <tr>
                        <th></th>
                        <th>NOMBRE</th>
                        <th >BANCO</th>
                        <th>NO. CUENTA</th>
                        <th>TIPO DE CUENTA</th>
                        <th>MONEDA</th>
                        <th>OBSERVACIONES</th>
                    </tr>
                    </thead>
                    <tbody >
                    {fields.map((contacto, index) => (
                        <tr key={index}>
                            <td className="text-center sin-borde-top" style={{width: "48px"}}>
                                <img className="action-img" src={require('assets/img/icons/Cerrar.png')} alt="Borrar"
                                     title="Borrar" 
                                     onClick={() =>{
                                         fields.remove(index)
                                     }}
                                />
                            </td>
                            <td className="sin-borde-top">
                                <Field
                                    name={`${contacto}.propietario`}
                                    type="text"
                                    component={renderField}
                                />
                            </td>
                            <td className="sin-borde-top" >
                                <Field
                                    name={`${contacto}.nombre_banco`}
                                    type="text"
                                    component={renderField}
                                />
                            </td>
                            <td className="sin-borde-top">
                                <Field
                                    name={`${contacto}.numero_cuenta`}
                                    type="text"
                                    component={renderField}
                                />
                            </td>
                            <td className="sin-borde-top">
                                <Field
                                    name={`${contacto}.tipo`}
                                    type="text"
                                    component={renderSelectField}
                                    options={TiposCuentas}
                                />
                            </td>
                            <td className="sin-borde-top">
                                <Field
                                    name={`${contacto}.moneda`}
                                    type="text"
                                    component={renderSelectField}
                                    options={Monedas}
                                />
                            </td>
                            <td className="sin-borde-top">
                                <Field
                                    name={`${contacto}.descripcion`}
                                    type="text"
                                    component={renderTextArea}
                                    rows={3}
                                />
                            </td>
                        </tr>
                    ))}
                    </tbody>
                </table>
            </div>
            <div className="d-flex justify-content-start mt-2">
                <button type="button" className="btn btn-primary py-0" onClick={() => fields.push({})}>
                    AGREGAR CUENTA
                </button>
            </div>
        </div>
    </div>
)

const CuentaForm = (props) => {
    const { handleSubmit, previousStep, permiso_cuenta } = props;
    return (
        <form name="CuentaForm" className="form-validate mb-lg" onSubmit={handleSubmit}>
            <div className="row justify-content-center">
                <h4 className="t-primary" >CUENTAS DE BANCO</h4>
            </div>
            <FieldArray name="cuenta" component={renderCuentas} />
            <div className="row  justify-content-sm-around justify-content-center">
                <button onClick={previousStep} className="btn btn-secondary m-1 align-self-center">ANTERIOR</button>                        
                <button type="submit" className="btn btn-primary m-1 align-self-center">{permiso_cuenta? 'SIGUIENTE':'REGISTRAR'}</button>
            </div>
        </form>
    );
};


export default reduxForm({
    form: 'ClientesForm', // a unique identifier for this form
    destroyOnUnmount: false, // <------ preserve form data
    forceUnregisterOnUnmount: true, // <------ unregister fields on unmount
    validate: (data) => {
        return validate(data, {
            nombre: validators.exists()('Este campo es requerido'),
            nit: validators.exists()('Este campo es requerido'),
            direccion: validators.exists()('Este campo es requerido'),
        });
    },
})(CuentaForm);
